interface SmallHeadingComponentProps {
    children: string
}

function SmallHeadingComponent(props: SmallHeadingComponentProps) {
    return <div className={"text-3xl font-bold"}>{props.children}</div>
}

export default SmallHeadingComponent
